import { api } from "../api.js";
import { notificationsSupported, requestPermission } from "./notify.js";
import { nativePushSupported, isNativePushEnabled, enableNativePush, disableNativePush } from "./nativePush.js";

export function pushSupported() {
  if (nativePushSupported()) return true; // FCM in the Android shell
  return notificationsSupported() && "PushManager" in window;
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
}

export async function isPushSubscribed() {
  if (nativePushSupported()) return isNativePushEnabled();
  if (!pushSupported()) return false;
  const reg = await navigator.serviceWorker.ready;
  return !!(await reg.pushManager.getSubscription());
}

/** Ensure permission + a push subscription, registering it with the server. */
export async function enablePush() {
  if (nativePushSupported()) return enableNativePush();
  if (!pushSupported()) throw new Error("Push isn't supported here");
  const perm = await requestPermission();
  if (perm !== "granted") throw new Error("Notifications were not allowed");

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { publicKey } = await api.pushKey();
    if (!publicKey) throw new Error("Server is missing its push key");
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }
  await api.pushSubscribe(sub.toJSON());
  return true;
}

export async function disablePush() {
  if (nativePushSupported()) return disableNativePush();
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    await api.pushUnsubscribe(sub.endpoint).catch(() => {});
    await sub.unsubscribe().catch(() => {});
  }
}
